import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_mst_label_exts_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
}

export class bl_inv_mst_label_exts_RowClass
  implements bl_inv_mst_label_exts_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
}
